function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1012.58968,734.18036H639.937a11.39106,11.39106,0,0,1-11.37819-11.37818v-263.424A11.39106,11.39106,0,0,1,639.937,448h372.65272a11.39106,11.39106,0,0,1,11.37819,11.37819v263.424A11.39106,11.39106,0,0,1,1012.58968,734.18036Z",
  transform: "translate(-176.03213 -165.81964)",
  fill: "#e6e6e6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M997.07559,463.51257H655.45582a11.39794,11.39794,0,0,0-11.38333,11.38327v232.388a11.398,11.398,0,0,0,11.38333,11.38333H997.07559a11.39064,11.39064,0,0,0,11.37473-11.38333v-232.388A11.39059,11.39059,0,0,0,997.07559,463.51257Z",
  transform: "translate(-176.03213 -165.81964)",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 638.05876,
  cy: 397.968,
  r: 45.87523,
  fill: "#a0616a"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M867.33893,659.63411l-81.92007,8.192c7.57211-34.08717,9.40751-65.93365,0-93.38887h57.34405C839.64771,597.31481,851.29151,627.39923,867.33893,659.63411Z",
  transform: "translate(-176.03213 -165.81964)",
  fill: "#a0616a"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M923.87379,659.8877c-1.02159,19.97658-2.20628,39.627-3.66564,58.77946H728.66621q-3.39955-18.96789-8.26707-38.17616a17.52166,17.52166,0,0,1,9.82944-20.35436l6.11231-2.72133L790.33011,633.421l.63526.13734,22.3031,4.77309L852.595,628.502l.68676.13734,55.13095,11.28031a19.64416,19.64416,0,0,1,4.70446,1.61393A19.38247,19.38247,0,0,1,923.87379,659.8877Z",
  transform: "translate(-176.03213 -165.81964)",
  fill: "#539dfe"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M953.79152,718.66716H912.40463l-7.38282-78.696a45.04,45.04,0,0,1,39.60125,35.49773Z",
  transform: "translate(-176.03213 -165.81964)",
  fill: "#539dfe"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M741.06248,718.66716H701.3754l1.42509-13.91583a53.24744,53.24744,0,0,1,33.46316-48.392l.07724,1.056Z",
  transform: "translate(-176.03213 -165.81964)",
  fill: "#539dfe"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M777.66872,537.64893c20.67775-11.8303,41.38337-4.27184,62.125,28.00769l4.24046,34.38524c31.12962-29.49122,29.55593-69.73744-5.35387-86.10671-3.43205-1.60926-6.75789-3.43956-10.49285-2.79276-16.14591-8.64605-35.449-2.15217-43.53854,11.69618-6.44976,1.117-15.69612,13.93094-15.36336,20.46829Z",
  transform: "translate(-176.03213 -165.81964)",
  fill: "#2f2e41"
});

var _ref10 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 661.81557,
  cy: 400.4256,
  rx: 5.7344,
  ry: 7.37281,
  fill: "#a0616a"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M664.99477,530.19528H190.51927a14.50353,14.50353,0,0,1-14.48714-14.48714V180.30677a14.50353,14.50353,0,0,1,14.48714-14.48713h474.4755a14.50353,14.50353,0,0,1,14.48714,14.48713V515.70814A14.50353,14.50353,0,0,1,664.99477,530.19528Z",
  transform: "translate(-176.03213 -165.81964)",
  fill: "#e6e6e6"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M645.24158,185.57082H210.27846a14.51228,14.51228,0,0,0-14.49368,14.49362V495.94959a14.51234,14.51234,0,0,0,14.49368,14.49369H645.24158a14.503,14.503,0,0,0,14.48274-14.49369V200.06444A14.50289,14.50289,0,0,0,645.24158,185.57082Z",
  transform: "translate(-176.03213 -165.81964)",
  fill: "#fff"
});

var _ref13 = /*#__PURE__*/React.createElement("polygon", {
  points: "353.705 230.274 219.549 260.975 162.866 154.068 277.58 109.282 353.705 230.274",
  fill: "#2f2e41"
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  cx: 240.38362,
  cy: 171.69169,
  r: 48.59396,
  fill: "#ffb9b9"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M410.77106,497.63871l117.96056-17.029c-17.60893-31.8719-35.76381-60.91952-60.16316-57.67181-21.70675-15.19226-22.95848-39.61456-17.46852-67.079l-59.04307,15.78327c5.19525,16.92984,3.18574,31.79571-10.65119,43.27336C400.73935,442.13171,413.25126,469.60385,410.77106,497.63871Z",
  transform: "translate(-176.03213 -165.81964)",
  fill: "#ffb9b9"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M553.56863,510.44328h-186.658q-3.96769-5.32857-8.43821-10.30734c-.19674-.22956-.40442-.47-.6121-.69956l5.017-70.92719.50282-7.17032a9.5472,9.5472,0,0,1,6.20845-8.29611h.01094a6.19606,6.19606,0,0,1,.86347-.29515l15.47745-4.13164,1.54115-.41536.21862.26232,8.68966,10.07777,5.804,6.74409,25.66449,29.78526a26.76556,26.76556,0,0,0,18.38489,9.22523l9.4985.66674c16.81091,1.19137,28.7141-12.41689,28.7141-26.85593A25.8691,25.8691,0,0,0,480.1821,423.842a26.40428,26.40428,0,0,0-2.31723-3.08237l10.79921,1.73789,15.47738,2.50309,17.44489,41.01078C539.11864,479.91476,550.19111,494.67076,553.56863,510.44328Z",
  transform: "translate(-176.03213 -165.81964)",
  fill: "#539dfe"
});

var _ref17 = /*#__PURE__*/React.createElement("polygon", {
  points: "152.415 283.359 175.882 325.791 162.645 338.109 155.639 344.624 94.822 344.624 131.275 305.843 152.415 283.359",
  fill: "#ffb9b9"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M566.34623,510.44328H509.093L503.0266,484.3306,490.096,428.66223l-1.43188-6.16474-.03282-.142,13.54274.81978a41.75438,41.75438,0,0,1,35.44719,24.34189Z",
  transform: "translate(-176.03213 -165.81964)",
  fill: "#539dfe"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M340.2588,506.30422l56.31409-19.06552-19.85495-67.55132a9.58647,9.58647,0,0,0-10.41056-6.80605h0a9.58639,9.58639,0,0,0-5.14893,2.33834l-57.527,51.03742C314.63663,484.37468,326.354,484.82946,340.2588,506.30422Z",
  transform: "translate(-176.03213 -165.81964)",
  fill: "#539dfe"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M448.69889,258.61857s29.71882,5.59009,36.59146,42.65492a68.044,68.044,0,0,1,.582,18.92569c-.68626,7.13458.30921,22.20363,15.80082,39.94727a388.439,388.439,0,0,1,28.20691,36.22531l0,0-31.05353,8.26685-13.87465-51.45A263.19676,263.19676,0,0,0,454.197,282.50133l-.28526-.45769s-10.31392,27.5585-37.958,31.33648l8.52361-11.22216s-32.31612,18.68115-50.625,24.38788a12.02949,12.02949,0,0,0-3.88182,20.91814q.19478.15319.39676.30662c13.4666,10.22834,40.93951,34.63415,30.08589,58.2435s1.8034,27.91394,1.8034,27.91394L378.91707,425.049l-10.68246-4.57446,1.07943,7.89831-52.14859,1.09252s-14.0919-.08559,10.93922-37.70124c0,0,6.0398-14.1044,1.08139-24.87967-3.80244-8.26322-6.158-17.13869-5.78024-26.227C324.98223,302.73378,340.958,225.58173,448.69889,258.61857Z",
  transform: "translate(-176.03213 -165.81964)",
  fill: "#2f2e41"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M847.81566,399.63818a1.00094,1.00094,0,0,1-.97852-.79638c-4.75781-22.88575-21.22265-43.91748-46.36035-59.22119-25.46875-15.5044-58.16894-24.04346-92.07617-24.04346a1,1,0,0,1,0-2c34.26855,0,67.33789,8.64258,93.11621,24.33545,25.61621,15.59424,42.40625,37.08838,47.2793,60.522a1.001,1.001,0,0,1-.98047,1.20361Z",
  transform: "translate(-176.03213 -165.81964)",
  fill: "#3f3d56"
});

var _ref22 = /*#__PURE__*/React.createElement("polygon", {
  points: "661.281 231.145 673.255 247.094 681.082 228.751 661.281 231.145",
  fill: "#3f3d56"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M591.49974,652.63184c-34.26855,0-67.33789-8.64258-93.11572-24.33594-25.6167-15.59473-42.40723-37.08789-47.2793-60.52246a.99986.99986,0,1,1,1.958-.40625c4.75781,22.88574,21.22266,43.917,46.36133,59.2207,25.46875,15.50488,58.16894,24.04395,92.07568,24.04395a1,1,0,0,1,0,2Z",
  transform: "translate(-176.03213 -165.81964)",
  fill: "#3f3d56"
});

var _ref24 = /*#__PURE__*/React.createElement("polygon", {
  points: "286.555 403.424 274.581 387.475 266.754 405.818 286.555 403.424",
  fill: "#3f3d56"
});

var SvgSession = function SvgSession(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a77d060e-bfde-44e4-9303-3da9960cf22f",
    "data-name": "Layer 1",
    viewBox: "0 0 847.93574 568.36073",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSession, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/session.275ddc9d.svg";
export { ForwardRef as ReactComponent };